import * as React from 'react';

const Calendar = ({fillColor = '#2961fa'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11.573} height={12.127}>
    <g data-name="Group 233941" fill={fillColor}>
      <path data-name="Path 58695" d="M.159 12.128H.001v-.158h.158v.158" />
      <path data-name="Path 58696" d="M11.573 12.128h-.159v-.158h.159v.158" />
      <path data-name="Path 58710" d="M.159.713H.001V.554h.158v.159" />
      <path data-name="Path 58711" d="M11.573.713h-.159V.554h.159v.159" />
      <path
        data-name="Path 59173"
        d="M1.347 10.78V4.439h8.878v6.341Zm1.268-8.878v.634h1.264V1.9h3.8v.634h1.268V1.9h1.268v1.268H1.337V1.9ZM10.224.634H8.956V0H7.688v.634h-3.8V0H2.62v.634H1.352A1.27 1.27 0 0 0 .079 1.9v8.878a1.269 1.269 0 0 0 1.268 1.268h8.878a1.27 1.27 0 0 0 1.268-1.268V1.9A1.27 1.27 0 0 0 10.225.632Z"
      />
      <path data-name="Path 59174" d="M2.616 6.975h1.268V5.707H2.616v1.268Z" />
      <path data-name="Path 59175" d="M5.152 6.975H6.42V5.707H5.152v1.268Z" />
      <path data-name="Path 59176" d="M7.689 5.707v1.268h1.268V5.707Z" />
      <path data-name="Path 59177" d="M2.616 9.511h1.268V8.243H2.616v1.268Z" />
      <path data-name="Path 59178" d="M5.152 9.511H6.42V8.243H5.152v1.268Z" />
      <path data-name="Path 59179" d="M7.689 9.511h1.268V8.243H7.689v1.268Z" />
    </g>
  </svg>
);

export default Calendar;
